import * as Actions from '@/lib/constants/annotations'

export default function useAnnotationPublisher({
  publish,
}: {
  // TODO: Should type action (after removing old constants) //
  publish: (event: { action: string; payload?: Object }) => void
}): DrawingObserver {
  return {
    setup(opts) {
      if (opts.strokeStyle) {
        publish({ action: Actions.SELECT_COLOR, payload: { color: opts.strokeStyle } })
      }
      if (opts.lineWidth) {
        publish({ action: Actions.SELECT_PEN, payload: { pen: opts.lineWidth } })
      }
    },
    start(point) {
      publish({ action: Actions.MOVE_TO, payload: { point } })
    },
    move(point) {
      publish({ action: Actions.LINE_TO, payload: { point } })
    },
    undo() {
      publish({ action: Actions.UNDO })
    },
    reset() {
      publish({ action: Actions.ERASE })
    },
  }
}
